import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OrderState } from './order.reducer';

export const getOrderFeatureState = createFeatureSelector<OrderState>('order');

export const getOrdersMap = createSelector(
  getOrderFeatureState,
  (state) => state.ordersMap.orders,
);
